import { apiClient } from "@/lib/apiClient";
import type { ParcelViewDto } from "@/types/domain";

export function getParcel(parcelNumber: number): Promise<ParcelViewDto> {
  return apiClient.get<ParcelViewDto>(
    `/api/parcels/${encodeURIComponent(String(parcelNumber))}`,
  );
}
